import axios from 'axios';

export const API_BASE_URL = 'https://rac-api.kathyelkhoury.com';

// Create axios instance with default config (no credentials for regular API calls)
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Separate axios instance for authenticated requests (like images)
export const authenticatedApiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

